export const INPUT = {
  SHAPE: { CIRCLE: "circle", DEFAULT: "default" },
  SIZE: { LARGE: "large", MEDIUM: "medium", SMALL: "small" },
};